import React from 'react';

import PropTypes from 'prop-types';

import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import { MATCHED, NOT_MATCHED } from 'apps/auth/constants/Constants';

const getIconName = (codeMatched, codeNotMatched) => {
    let iconName;
    if (codeMatched) {
        iconName = 'check-rounded';
    } else if (codeNotMatched) {
        iconName = 'cross-rounded';
    } else {
        iconName = 'info-rounded';
    }
    return iconName;
};

const PreCheckRecipient = (props) => {
    const {
        preCheck: { nameTo },
        paymentForm: { recipientComment = '' },
        code = '',
        messages,
        popupRef,
    } = props;
    const statusNotMatched = code === NOT_MATCHED;
    const statusMatched = code === MATCHED;

    const getText = (text) => {
        return <DangerouslyHtml dangerouslyHtml={text} />;
    };
    const popup = (
        <SimplePopup popupRef={popupRef} text={getText(recipientComment)} handleClose={props.closeHandlerForPopup}>
            <PopupButton
                iconName="check"
                text={messages.gotIt}
                onClick={(e) => {
                    e.preventDefault();
                    props.closeHandlerForPopup();
                }}
            />
        </SimplePopup>
    );

    const onClickHandler = () => {
        if (recipientComment) {
            popupRef?.current?.open(popup);
        }
    };

    return (
        <TableRow pseudoTable title={messages.chequeRecipientHeader} onClick={onClickHandler}>
            <Text color={statusNotMatched ? 'error' : 'primary'} size="secondary">
                {nameTo}
                {recipientComment && (
                    <DiskButton
                        type="button"
                        iconColor={statusNotMatched ? 'error' : 'primary'}
                        iconName={getIconName(statusMatched, statusNotMatched)}
                        size="small"
                        marginRight="-8px"
                        marginTop="-4px"
                    />
                )}
            </Text>
        </TableRow>
    );
};
PreCheckRecipient.propTypes = {
    preCheck: PropTypes.object,
    paymentForm: PropTypes.object,
    closeHandlerForPopup: PropTypes.func,
    code: PropTypes.string,
    messages: PropTypes.object,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};
export default PreCheckRecipient;
